import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCancelHelprequest = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 28" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#FFF">
      <path d="M4.517 8.126a10.429 10.429 0 0 0-1.877 6.171c.1 5.785 4.872 10.393 10.657 10.292a10.427 10.427 0 0 0 5.55-1.705m3.085-3.111a10.427 10.427 0 0 0 1.657-5.842C23.488 8.146 18.716 3.54 12.93 3.64c-1.935.033-3.738.59-5.278 1.532" />
      <path d="M9.443 12.091a4.19 4.19 0 0 0 5.24 5.91m2.415-2.584a4.19 4.19 0 0 0-5.378-5.256m1.34-6.449c.952 2.14.987 4.13.104 5.967m.123 8.626c1.228 1.961 1.265 4.051.11 6.27M2.687 14.203c2.191-1.107 4.28-1.144 6.265-.11m8.398-.026c2.305-1.214 4.4-1.25 6.284-.11m-8.256-9.876c.87-1.546 1.736-2.216 2.6-2.012 1.295.306 2.237 2.23 3.92 4.208 1.684 1.977 2.95 2.951 3.307 4.678.239 1.151-.507 1.795-2.238 1.931M10.695 24.767c-.87 1.546-1.736 2.217-2.6 2.013-1.295-.306-2.237-2.23-3.921-4.208C2.49 20.594 1.225 19.62.868 17.894c-.239-1.152.507-1.795 2.238-1.932m19.821-.054c1.998.767 2.932 1.59 2.804 2.468-.192 1.318-2.027 2.424-3.85 4.273-1.824 1.85-2.683 3.195-4.372 3.702-1.127.338-1.885-.31-2.275-1.941M2.792 11.586C1.176 10.855.432 10.05.561 9.172c.142-.977 1.189-1.838 2.464-2.973m2.561-2.545c1.11-1.204 1.915-2.072 3.197-2.457 1.126-.338 1.833.35 2.119 2.062M.97 1.518l25.304 25.777" />
    </g>
  </svg>
);
const Memo = memo(SvgCancelHelprequest);
export default Memo;
